import { Component, inject } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'lib-custom-snackbar',
  standalone: true,
  imports: [MatIconModule, CommonModule],
  templateUrl: './custom-snackbar.component.html',
  styleUrls: ['./custom-snackbar.component.scss'],
})
export class CustomSnackbarComponent {
  snackBarRef = inject(MatSnackBarRef);
  data: { message: string | { description: string }[], type: 'success' | 'error'} = inject(MAT_SNACK_BAR_DATA);

  get icon(): string {
    if (this.data.type === 'success') {
      return 'check_circle';
    }
    return 'close';
  }

  get message(): string | { description: string }[] {
    return this.data.message;
  }

  isString(value: any): value is string {
    return typeof value === 'string';
  }

  dismiss() {
    this.snackBarRef.dismiss();
  }
}
